import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  InfraTicketDescriptionDialogContext,
  InfraTicketDescriptionDialogInitialState,
} from ".";

export const InfraTicketDescriptionDialogStateProvider = ({
  children,
}: any) => {
  const [pageState, setPageState] = useState(
    InfraTicketDescriptionDialogInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <InfraTicketDescriptionDialogContext.Provider value={context}>
      {children}
    </InfraTicketDescriptionDialogContext.Provider>
  );
};
